import { createReducer, on } from '@ngrx/store';

import { loadParametersProductListFilterFail, loadParametersProductListFilterSuccess } from './parameters.actions';

export interface ParametersState {
  productLists: Record<string, string[]>;
}

const initialState: ParametersState = {
  productLists: {},
};

export const parametersReducer = createReducer(
  initialState,
  on(loadParametersProductListFilterSuccess, (state, action): ParametersState => ({
    ...state,
    productLists: { ...state.productLists, [action.payload.id]: action.payload.productList },
  })),
  /* DIAS Customization Start */
  // e.g. the list's category is hidden by the customer segment's catalog view: show no products rather than
  // keeping a list fetched for another customer
  on(loadParametersProductListFilterFail, (state, action): ParametersState =>
    action.payload.id ? { ...state, productLists: { ...state.productLists, [action.payload.id]: [] } } : state
  )
  /* DIAS Customization End */
);
